import { render, staticRenderFns } from "./injection.vue?vue&type=template&id=335ddf6c&scoped=true&"
import script from "./injection.vue?vue&type=script&lang=js&"
export * from "./injection.vue?vue&type=script&lang=js&"
import style0 from "./injection.vue?vue&type=style&index=0&id=335ddf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ddf6c",
  null
  
)

export default component.exports